import React, { useState } from 'react';
import { offersApi } from '../../services/api';
import './SimpleOfferForm.css';

interface SimpleOfferFormProps {
  requestId: string;
  existingOffer?: any;
  onSuccess: () => void;
  onCancel: () => void;
}

function SimpleOfferForm({ requestId, existingOffer, onSuccess, onCancel }: SimpleOfferFormProps) {
  const [offerText, setOfferText] = useState(existingOffer?.description || '');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!offerText.trim()) {
      setError('Please enter your offer');
      return;
    }

    setSubmitting(true);
    setError('');

    try {
      if (existingOffer) {
        // Update existing offer
        await offersApi.update(existingOffer.id, { description: offerText });
      } else {
        // Create new offer
        await offersApi.create({
          requestId,
          description: offerText
        });
      }
      onSuccess();
    } catch (err: any) {
      setError(err.response?.data?.error || 'Failed to submit offer');
      setSubmitting(false);
    }
  };

  return (
    <div className="simple-offer-form">
      <h3>{existingOffer ? 'Edit Offer' : 'Make an Offer'}</h3>
      <form onSubmit={handleSubmit}>
        {error && <div className="error-message">{error}</div>}

        <div className="form-group">
          <label htmlFor="offerText">Your Offer <span className="required">*</span></label>
          <textarea
            id="offerText"
            value={offerText}
            onChange={(e) => setOfferText(e.target.value)}
            placeholder="Describe what you can provide in response to this request..."
            rows={6}
            required
            disabled={submitting}
          />
          <small>Provide details about your offer including resources, capabilities, timeline, etc.</small>
        </div>

        <div className="form-actions">
          <button type="button" onClick={onCancel} className="btn btn-secondary" disabled={submitting}>
            Cancel
          </button>
          <button type="submit" className="btn btn-primary" disabled={submitting}>
            {submitting ? 'Submitting...' : existingOffer ? 'Update Offer' : 'Submit Offer'}
          </button>
        </div>
      </form>
    </div>
  );
}

export default SimpleOfferForm;
